











import { Component, Vue } from 'vue-property-decorator';
import CertReqForm from '@/components/forms/CertReqForm.vue';

@Component({
    components: {
        CertReqForm
    }
})
export default class CertificateRequestForm extends Vue {
}
